import { ContainerApiSuccessResponse } from '../../containerApi.types'

// Matches the backend's SupportedLocales (go-backend-api/internal/data/models
// LocalizedText) and this app's own i18n languages (shared/constants/Languages).
type TutorialVideoLocale = 'en' | 'de' | 'fr' | 'es' | 'it' | 'pt' | 'zh'

// A translatable field, e.g. { en: "Getting started", de: "Erste Schritte" }.
// Locales without a translation are simply absent from the object.
type TutorialVideoLocalizedText = Partial<Record<TutorialVideoLocale, string>>

interface TutorialVideoChapter {
  id: string
  name: TutorialVideoLocalizedText
  start_seconds: number
}

export interface TutorialVideo {
  id: string
  title: TutorialVideoLocalizedText
  app_id: string
  video_url: string
  duration_seconds: number
  chapters: TutorialVideoChapter[]
  is_global: boolean
  is_active: boolean
}

export interface GetTutorialVideosResponse
  extends ContainerApiSuccessResponse<TutorialVideo[]> {}
